import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  createModelConceptHierarchy,
  getModelConceptHierarchyKey,
} from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchy';
import { createModelConceptHierarchyLabel } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchyLabel';
import { RDFS_SUB_CLASS_OF_IRI } from 'src/templates/queries/iris';

export const addModelConceptHierarchy =
  ({
    fromIri,
    value = RDFS_SUB_CLASS_OF_IRI,
    toIri,
  }: {
    fromIri: string;
    toIri: string;
    value?: string;
  }) =>
  (model: Model) => {
    const key = getModelConceptHierarchyKey({ fromIri, value, toIri });
    const existingLinkData = model.linkDataArray.find(
      (link) => link.key === key
    );

    if (existingLinkData) {
      return;
    }

    const newHierarchy = createModelConceptHierarchy({ fromIri, value, toIri });
    const newHierarchyLabel = createModelConceptHierarchyLabel({
      fromIri,
      value,
      toIri,
    });

    model.addLinkData(newHierarchy);
    model.addNodeData(newHierarchyLabel);
  };
